import { render, staticRenderFns } from "./UPEIRedoxPreLab.vue?vue&type=template&id=680d3e1b&"
import script from "./UPEIRedoxPreLab.vue?vue&type=script&lang=js&"
export * from "./UPEIRedoxPreLab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
